<template>
	<div>
		
		<stato-fase
			:fase-with-stati="faseWithStati"
			:pratica="pratica"
			:pratica-diff="praticaDiff"
			@update-id-stato="pratica.id_stato_fase_2 = $event"
			:disabled="isLoading"
			:action="action"
		></stato-fase>
		
		<!--<div-->
		<!--	:style="`height: 1px; background-color: ${$vuetify.theme.currentTheme.primary}`"-->
		<!--	class="my-4"-->
		<!--&gt;</div>-->
		
		<!--<v-row class="mb-5 font-weight-medium">-->
		<!--	<v-col>-->
		<!--		<div v-html="faseWithStati.descrizione"></div>-->
		<!--	</v-col>-->
		<!--</v-row>-->
		
		<v-sheet
			rounded
			color="primary"
			class="my-5 px-4 text-h6"
		>
			<span class="tertiary--text">
				Dati Pratica
			</span>
		</v-sheet>
		
		<v-row>
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('ragione_sociale')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.ragione_sociale"
						@input="pratica.ragione_sociale = $event !== '' ? $event : null"
						label="Ragione Sociale"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('partita_iva_codice_fiscale')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.partita_iva_codice_fiscale"
						@input="pratica.partita_iva_codice_fiscale = $event !== '' ? $event : null"
						label="Partita IVA / Codice Fiscale"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
			<!--<v-col cols="6">-->
			<!--	<v-badge-->
			<!--		:value="praticaDiff.includes('denominazione')"-->
			<!--		class="d-block"-->
			<!--		color="info"-->
			<!--		overlap-->
			<!--		right-->
			<!--		icon="mdi-pencil"-->
			<!--	>-->
			<!--		<v-text-field-->
			<!--			:value="pratica.denominazione"-->
			<!--			@input="pratica.denominazione = $event !== '' ? $event : null"-->
			<!--			label="Denominazione"-->
			<!--			outlined-->
			<!--			dense-->
			<!--			hide-details-->
			<!--			:readonly="action == 'show' || !isAccountManager"-->
			<!--			:disabled="isLoading"-->
			<!--			:persistent-placeholder="isCliente"-->
			<!--		></v-text-field>-->
			<!--	</v-badge>-->
			<!--</v-col>-->
		</v-row>
		
		<v-row>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('codice_identificativo')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.codice_identificativo"
						@input="pratica.codice_identificativo = $event !== '' ? $event : null"
						label="Codice identificativo"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('codice_ditta')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.codice_ditta"
						@input="pratica.codice_ditta = $event !== '' ? $event : null"
						label="Codice Ditta"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
		</v-row>
		
		<v-row>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('regione')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-select
						v-model="pratica.regione"
						label="Regione"
						:items="regioniItems"
						outlined
						dense
						hide-details
						clearable
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-select>
				</v-badge>
			</v-col>
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('asse_di_finanziamento_id')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-select
						v-model="pratica.asse_di_finanziamento_id"
						label="Asse di Finanziamento"
						:items="assiDiFinanziamento"
						item-text="nome"
						item-value="id"
						:loading="isLoadingAssiDiFinanziamento"
						outlined
						dense
						hide-details
						clearable
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-select>
				</v-badge>
			</v-col>
		</v-row>
		
		<v-row>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('agevolazione_richiesta')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.agevolazione_richiesta"
						@input="pratica.agevolazione_richiesta = $event !== '' ? $event : null"
						label="Importo Agevolazione"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
						:rules="[mixin_rules.max_7_interi_2_decimali_e_virgola]"
					></v-text-field>
				</v-badge>
			</v-col>
			<v-col>
				<v-badge
					:value="praticaDiff.includes('pec')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.pec"
						@input="pratica.pec = $event !== '' ? $event : null"
						label="PEC primaria dell'azienda associata alla domanda"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
		</v-row>
		
		<v-row class="mt-0">
			<v-col class="d-flex align-center">
				<div class="mr-3">
					La PEC primaria dell'azienda associata alla domanda è abilitata a ricevere email ordinarie (ovvero non PEC)?
				</div>
				<v-badge
					:value="praticaDiff.includes('is_pec_abilitata')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-radio-group
						v-model="pratica.is_pec_abilitata"
						class="mt-0"
						row
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
					>
						<v-radio
							label="Si"
							:value="true"
						></v-radio>
						<v-radio
							label="No"
							:value="false"
						></v-radio>
					</v-radio-group>
				</v-badge>
			</v-col>
		</v-row>
		
		<v-row class="mt-6">
			<v-col cols="6">
				<v-badge
					:value="praticaDiff.includes('numero_di_emergenza')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.numero_di_emergenza"
						@input="pratica.numero_di_emergenza = $event !== '' ? $event : null"
						label="Numero di emergenza"
						outlined
						dense
						hide-details
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
			<v-col v-if="isAccountManager" cols="2">
				<v-badge
					:value="praticaDiff.includes('priorita')"
					class="d-block"
					color="info"
					overlap
					right
					icon="mdi-pencil"
				>
					<v-text-field
						:value="pratica.priorita"
						@input="pratica.priorita = $event !== '' ? parseInt($event) : null"
						label="Priorità"
						outlined
						dense
						hide-details
						type="number"
						min="0"
						:readonly="action == 'show' || !isAccountManager"
						:disabled="isLoading"
						:rules="[mixin_rules.min0]"
						:persistent-placeholder="isCliente"
					></v-text-field>
				</v-badge>
			</v-col>
		</v-row>
		
		<template v-if="!isCoordinatore">
			<v-sheet
				rounded
				color="primary"
				class="my-5 px-4 mt-10 text-h6"
			>
				<span class="tertiary--text">
					Dati Contratto di Servizio
				</span>
			</v-sheet>
			
			<template v-if="pratica.contratto_di_servizio_id === null">
				Contratto di Servizio non ancora caricato
			</template>
			
			<template v-else>
				<v-row>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('ragione_sociale')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.ragione_sociale"
								@input="pratica.contratto_di_servizio.ragione_sociale = $event !== '' ? $event : null"
								label="Ragione sociale"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
							></v-text-field>
						</v-badge>
					</v-col>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('partita_iva')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.partita_iva"
								@input="pratica.contratto_di_servizio.partita_iva = $event !== '' ? $event : null"
								label="Partita IVA"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
							></v-text-field>
						</v-badge>
					</v-col>
				</v-row>
				
				<v-row>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('indirizzo_fatturazione')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.indirizzo_fatturazione"
								@input="pratica.contratto_di_servizio.indirizzo_fatturazione = $event !== '' ? $event : null"
								label="Indirizzo di Fatturazione"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
							></v-text-field>
						</v-badge>
					</v-col>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('pec')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.pec"
								@input="pratica.contratto_di_servizio.pec = $event !== '' ? $event : null"
								label="PEC"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
							></v-text-field>
						</v-badge>
					</v-col>
				</v-row>
				
				<!--<v-row>-->
					<!--<v-col>-->
					<!--	<v-badge-->
					<!--		:value="contrattoDiServizioDiff.includes('data_di_nascita')"-->
					<!--		class="d-block"-->
					<!--		color="info"-->
					<!--		overlap-->
					<!--		right-->
					<!--		icon="mdi-pencil"-->
					<!--	>-->
					<!--		<v-menu-->
					<!--			v-model="menuDataDiNascita"-->
					<!--			:close-on-content-click="false"-->
					<!--			max-width="290"-->
					<!--		>-->
					<!--			<template v-slot:activator="{ on, attrs }">-->
					<!--				<v-text-field-->
					<!--					:value="formatDateToItaly(pratica.contratto_di_servizio.data_di_nascita)"-->
					<!--					label="Data di Nascita"-->
					<!--					outlined-->
					<!--					dense-->
					<!--					hide-details-->
					<!--					readonly-->
					<!--					:disabled="isLoading"-->
					<!--					:clearable="isAccountManager"-->
					<!--					v-bind="attrs"-->
					<!--					v-on="isAccountManager ? on : null"-->
					<!--					@click:clear="pratica.contratto_di_servizio.data_di_nascita = null"-->
					<!--					:persistent-placeholder="isCliente"-->
					<!--				></v-text-field>-->
					<!--			</template>-->
					<!--			<v-date-picker-->
					<!--				:value="pratica.contratto_di_servizio.data_di_nascita"-->
					<!--				@input="pratica.contratto_di_servizio.data_di_nascita = $event !== '' ? $event : null"-->
					<!--				@change="menuDataDiNascita = false"-->
					<!--				:readonly="action == 'show' || !isAccountManager"-->
					<!--				first-day-of-week="1"-->
					<!--			></v-date-picker>-->
					<!--		</v-menu>-->
					<!--	</v-badge>-->
					<!--</v-col>-->
					<!--<v-col>-->
					<!--	<v-badge-->
					<!--		:value="contrattoDiServizioDiff.includes('luogo_di_nascita')"-->
					<!--		class="d-block"-->
					<!--		color="info"-->
					<!--		overlap-->
					<!--		right-->
					<!--		icon="mdi-pencil"-->
					<!--	>-->
					<!--		<v-text-field-->
					<!--			:value="pratica.contratto_di_servizio.luogo_di_nascita"-->
					<!--			@input="pratica.contratto_di_servizio.luogo_di_nascita = $event !== '' ? $event : null"-->
					<!--			label="Luogo di Nascita"-->
					<!--			outlined-->
					<!--			dense-->
					<!--			hide-details-->
					<!--			:readonly="action == 'show' || !isAccountManager"-->
					<!--			:disabled="isLoading"-->
					<!--			:persistent-placeholder="isCliente"-->
					<!--		></v-text-field>-->
					<!--	</v-badge>-->
					<!--</v-col>-->
				<!--</v-row>-->
				
				<v-row>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('codice_univoco')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.codice_univoco"
								@input="pratica.contratto_di_servizio.codice_univoco = $event !== '' ? $event : null"
								label="Codice Univoco"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
							></v-text-field>
						</v-badge>
					</v-col>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('tipo')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-select
								:items="tipiContrattoDiServizioOld"
								v-model="pratica.contratto_di_servizio.tipo"
								label="Tipo"
								outlined
								dense
								hide-details
								clearable
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:persistent-placeholder="isCliente"
							></v-select>
						</v-badge>
					</v-col>
				</v-row>
				
				<v-row>
					<v-col class="d-flex align-center">
						<div class="mr-3">
							Gold
						</div>
						<v-badge
							:value="contrattoDiServizioDiff.includes('is_gold')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-radio-group
								v-model="pratica.contratto_di_servizio.is_gold"
								class="mt-0"
								row
								hide-details
								:disabled="isLoading"
								:readonly="action == 'show' || !isAccountManager"
							>
								<v-radio
									label="Si"
									:value="true"
								></v-radio>
								<v-radio
									label="No"
									:value="false"
								></v-radio>
							</v-radio-group>
						</v-badge>
					</v-col>
					<v-col>
						<v-badge
							:value="contrattoDiServizioDiff.includes('numero_domande')"
							class="d-block"
							color="info"
							overlap
							right
							icon="mdi-pencil"
						>
							<v-text-field
								:value="pratica.contratto_di_servizio.numero_domande"
								@input="pratica.contratto_di_servizio.numero_domande = $event !== '' ? parseInt($event) : null"
								label="Numero Domande"
								type="number"
								min="0"
								outlined
								dense
								hide-details
								:readonly="action == 'show' || !isAccountManager"
								:disabled="isLoading"
								:rules="[mixin_rules.min0]"
								:persistent-placeholder="isCliente"
							></v-text-field>
						</v-badge>
					</v-col>
				</v-row>
			</template>
		</template>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/event-bus";
const mime = require('mime');
export default {
	props: ['value', 'action', 'faseWithStati', 'praticaDiff', 'contrattoDiServizioDiff'],
	data() {
		return {
			isSettingPratica: false,
			pratica: {
				id: null,
				id_stato_fase_2: null,
				ci_sono_aggiornamenti_fase_2: false,
				ragione_sociale: null,
				agevolazione_richiesta: null,
				denominazione: null,
				codice_identificativo: null,
				codice_ditta: null,
				regione: null,
				asse_di_finanziamento: null,
				pec: null,
				is_pec_abilitata: null,
				numero_di_emergenza: null,
				priorita: null,
				contratto_di_servizio_id: null,
				contratto_di_servizio: {
					id: null,
					ragione_sociale: null,
					partita_iva: null,
					indirizzo_fatturazione: null,
					data_di_nascita: null,
					luogo_di_nascita: null,
					pec: null,
					codice_univoco: null,
					tipo: null,
					is_gold: false,
					numero_domande: null
				}
			},
			isLoadingAssiDiFinanziamento: false,
			assiDiFinanziamento: [],
			menuDataDiNascita: false
		}
	},
	
	created() {
		this.isSettingPratica = true;
		// this.pratica = Object.assign({}, this.value);
		this.pratica = this.value;
		this.isSettingPratica = false;
		
		// aggiorno sul db
		if (this.pratica.ci_sono_aggiornamenti_fase_2 && this.isCliente) {
			this.pratica.ci_sono_aggiornamenti_fase_2 = false;
			this.$emit('input', this.pratica);
			this.$emit('aggiornamenti-visualizzati', {
				praticaId: this.pratica.id,
				aggiornamentoKey: 'ci_sono_aggiornamenti_fase_2',
				aggiornamentoValue: false
			});
			this.salvaAggiornamentiVisualizzati(this.pratica.id, 'ci_sono_aggiornamenti_fase_2');
		}
		
		this.getAssiDiFinanziamento();
	},
	
	computed: {
		...mapGetters({
			isAccountManager: 'auth/isAccountManager',
			isCliente: 'auth/isCliente',
			isCoordinatore: 'auth/isCoordinatore',
			bando: 'shared/bando'
		}),
		isLoading() {
			return this.isSettingPratica
				|| this.isLoadingAssiDiFinanziamento;
		}
	},
	
	watch: {
		pratica: {
			handler(newPratica) {
				if (!this.isLoading) {
					this.$emit('input', newPratica)
				}
			},
			deep: true
		},
		isLoading(newVal) {
			this.$emit('is-loading', newVal)
		},
	},
	
	methods: {
		getAssiDiFinanziamento() {
			this.isLoadingAssiDiFinanziamento = true;
			axios.get('/api/assi-di-finanziamento', {
				params: {
					bando_id: this.bando.id
				}
			})
				.then(response => {
					this.assiDiFinanziamento = response.data;
				})
				.finally(() => {
					this.isLoadingAssiDiFinanziamento = false;
				})
		},
	}
	
}
</script>

<style scoped>

</style>